import { Box, Button, Flex, Radio, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck } from "@tabler/icons-react";
import { useState } from "react";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";

const UpdateAlwaysInStock = ({
  ids,
  onSuccess,
}: {
  ids: string[];
  onSuccess: any;
}) => {
  const [visible, { open, close }] = useDisclosure(false);
  const [value, setValue] = useState<string>("1");

  const handleUpdate = async () => {
    if (!ids || ids.length === 0) {
      NotificationExtension.Fails("Vui lòng chọn ít nhất một sản phẩm !");
      return;
    }

    open();
    try {
      let url = `/api/v1/TblItem/update-attribute56?Value=${value}`;
      url += "&" + ids.map((i) => `Ids=${i}`).join("&");

      const res = await repositoryPos.post<MessageResponse<any>>(url);

      if (res && res.success) {
        NotificationExtension.Success("Cập nhật thành công !");
        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1000);
      } else {
        NotificationExtension.Fails(res?.message ?? "Cập nhật thất bại !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  return (
    <Box size={"auto"}>
      <Text size="16px" mt={10} fw={500}>
        Cập nhật cho <b>{ids?.length ?? 0}</b> sản phẩm đã chọn:
      </Text>
      <Radio.Group mt={15} value={value} onChange={setValue}>
        <Stack gap="xs">
          <Radio value="1" label="Luôn luôn có tồn ít nhất là 1" />
          <Radio value="0" label="Không yêu cầu" />
        </Stack>
      </Radio.Group>
      <Flex justify="center" mt={20}>
        <Button
          color="teal"
          disabled={visible}
          loading={visible}
          onClick={handleUpdate}
          leftSection={<IconCheck size={18} />}
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default UpdateAlwaysInStock;
